module.exports = "https://r.nearpod.com/assets/media/image/collapse-arrow-b724c863dd7c4fd5bcdb8e180fc8ff62.svg";